<template>
  <div>
    <v-container>
      <DadosColaborador :dadosColaborador="dadosColaborador" />

      <v-form>
        <v-row>
          <v-col cols="12">
            <span class="titulo-form">Plano de Ação para Desenvolvimento</span>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="planoAcao.objetivo"
              label="Objetivo"
              outlined
              hide-details="auto"
              :disabled="disabled || idPdi"
            ></v-textarea>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="planoAcao.acao"
              label="Ação"
              outlined
              hide-details="auto"
              :disabled="disabled || idPdi"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="planoAcao.idPrioridade"
              label="Prioridade"
              :items="prioridades"
              item-value="id"
              item-text="descricao"
              outlined
              dense
              hide-details="auto"
              :disabled="disabled || idPdi"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="planoAcao.idStatus"
              label="Status"
              :items="status"
              item-value="id"
              item-text="descricao"
              outlined
              dense
              hide-details="auto"
              :disabled="disabled"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <DatePicker2 v-model="planoAcao.prazo" label="Prazo" :disabled="disabled || idPdi" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span class="titulo-form">Monitoramento de Progresso</span>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="planoAcao.comentario"
              label="Descrição do Progresso"
              outlined
              hide-details="auto"
              :disabled="disabled"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="4" lg="2">
            <v-btn @click="cancelForm" class="w-100 botao-cancelar">
              {{ disabled ? 'Voltar' : 'Cancelar' }}
            </v-btn>
          </v-col>
          <v-col v-if="!disabled" cols="12" sm="6" md="4" lg="2">
            <v-btn @click="submitForm" class="w-100 botao-principal">Salvar</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-container v-if="idPdi">
      <v-divider class="mt-4 mb-8"></v-divider>

      <v-row>
        <v-col cols="12">
          <h2 class="titulo-secao">Acompanhamento de Progresso</h2>
        </v-col>
        <v-col cols="12">
          <TimelinePdi :historicoProgresso="historicoProgresso" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DadosColaborador from '../DadosColaborador.vue';
import TimelinePdi from './TimelinePdi.vue';
import DatePicker2 from '@/components/DatePicker2.vue';
import api from '@/services/Api.js';

export default {
  name: 'ViewFormPdi',
  components: { DadosColaborador, TimelinePdi, DatePicker2 },
  props: {
    idPdi: { type: [Number, null], default: null },
    dadosColaborador: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      prioridades: [],
      status: [],
      planoAcao: {
        objetivo: '',
        acao: '',
        idPrioridade: null,
        idStatus: null,
        prazo: '',
        comentario: '',
      },
      historicoProgresso: [],
    };
  },
  methods: {
    async fetchPrioridades() {
      try {
        const { data } = await api.get(`pdi/prioridades`);
        this.prioridades = data;
      } catch (e) {
        this.$emit('error', e.message);
      }
    },
    async fetchStatus() {
      try {
        const { data } = await api.get(`pdi/status`);
        this.status = data.filter(s => s.id !== 3);
      } catch (e) {
        this.$emit('error', e.message);
      }
    },
    async fetchPdiData() {
      if (!this.idPdi) return;

      try {
        const { data } = await api.get(`pdi/${this.idPdi}`);
        this.planoAcao = {
          objetivo: data.objetivo || '',
          acao: data.acao || '',
          idPrioridade: data.idPrioridade || null,
          idStatus: data.idStatus || null,
          prazo: data.prazo || '',
          comentario: data.comentario || '',
        };
        this.fetchProgresso();
      } catch (e) {
        this.$emit('error', e.message);
      }
    },
    async fetchProgresso() {
      if (!this.idPdi) return;

      try {
        const { data } = await api.get(`pdi/acompanhamento-progresso/${this.idPdi}`);
        this.historicoProgresso = data;
      } catch (e) {
        this.$emit('error', e.message);
      }
    },
    cancelForm() {
      this.$emit('toggle-form');
    },
    submitForm() {
      this.$emit('save-form', this.idPdi, this.planoAcao);
    },
    resetForm() {
      this.planoAcao = {
        objetivo: '',
        acao: '',
        idPrioridade: null,
        idStatus: null,
        prazo: '',
        comentario: '',
      };
    },
  },
  watch: {
    idPdi: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchPdiData();
        } else {
          this.resetForm();
        }
      },
    },
  },
  async mounted() {
    this.fetchPrioridades();
    this.fetchStatus();
  },
};
</script>

<style scoped>
.titulo-form {
  border-left: 6px solid #278b97;
  border-radius: 4px;
  padding-left: 0.75rem;
  color: #278b97;
  font-size: 1rem;
  font-weight: 900;
}
</style>
